var map = {
	"./bolsa_mensajeria.jpg": 3513,
	"./coordinadora.png": 5469,
	"./logo-envia.png": 22327,
	"./logo-mi-paquete-color.png": 43756,
	"./logo-tempo.png": 6481,
	"./logo.png": 59791,
	"./logo2.png": 79149,
	"./logotiendamipaquete.svg": 4607,
	"./mi-paquete-box.png": 68886,
	"./placeholder.png": 39027,
	"./serviefectivo.jpg": 22964,
	"./servientrega.png": 1885,
	"./tcc.png": 78674,
	"./tempo-express.jpeg": 92843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7616;